import Swiper from "swiper";
import { Controller, EffectFade, Autoplay, Navigation } from "swiper/modules";

document.addEventListener('DOMContentLoaded', () => {
    const galleryHolder = document.querySelector(".background-image .bg-image-slider");
    if (galleryHolder) {

        new Swiper(galleryHolder, {
            modules: [Controller, Autoplay, EffectFade, Navigation],
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            slidesPerView: 1,
            autoplay: {
                delay: 6000,
            }
        });
    }

    // checking if background image contains "clickhere-atmax", then add effect of day/night
    const clickhereAtmaxEl = document.querySelector(".background-image .clickhere-atmax");
    const clickhereLinkAtmaxEl = document.querySelector(".background-image .clickhere-atmax-link a");

    if(clickhereAtmaxEl) {
        const atMaxElClick = function (event) {
            event.stopPropagation();
            event.preventDefault();
            const bgEl = clickhereAtmaxEl.closest('.bg-style-banner-gradient-over-image-reverse');
            if(bgEl) {
                if(bgEl.classList.contains('darker-bg-animate')) {
                    bgEl.classList.remove('darker-bg-animate');
                } else {
                    bgEl.classList.add('darker-bg-animate');
                }
            }

            return false;
        };
        clickhereAtmaxEl.addEventListener('click', atMaxElClick);
        if(clickhereLinkAtmaxEl) {
            clickhereLinkAtmaxEl.addEventListener('click', atMaxElClick);
        }
    }
});
